<template>
  <div class="container">
    <h1 class="has-text-weight-bold title">Reports</h1>
    <div class="tabs is-boxed is-medium">
      <ul>
        <!-- Document reports -->
        <li
          :class="{ 'is-active': active === 'ReportDocument' ? true : false }"
        >
          <a @click="active = 'ReportDocument'" class="button">
            <span class="icon is-small">
              <i class="fas fa-file" aria-hidden="true"></i>
            </span>
            <span>Documents</span>
          </a>
        </li>
        <!-- Link reports -->
        <li :class="{ 'is-active': active === 'ReportLink' ? true : false }">
          <a @click="active = 'ReportLink'" class="button">
            <span class="icon is-small">
              <i class="fas fa-link" aria-hidden="true"></i>
            </span>
            <span>Campaigns</span>
          </a>
        </li>
        <!-- Group reports -->
        <!-- <li :class="{ 'is-active': active === 'ReportGroup' ? true : false }">
          <router-link
            class="button disabled tooltip is-tooltip-left"
            to="/upgrade"
            data-tooltip="This is a premium feature. Please upgrade your plan to gain access."
            v-if="disableGroups"
          >
            <span class="icon is-small">
              <i class="fas fa-object-group" aria-hidden="true"></i>
            </span>
            <span>Groups</span>
          </router-link>
          <a @click="active = 'ReportGroup'" class="button" v-else>
            <span class="icon is-small">
              <i class="fas fa-object-group" aria-hidden="true"></i>
            </span>
            <span>Groups</span>
          </a>
        </li> -->
      </ul>
    </div>
    <div class="container">
      <component :is="active" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'Reports',
  components: {
    ReportDocument: () => import(`@/components/reports/ReportDocument`),
    ReportGroup: () => import(`@/components/reports/ReportGroup`),
    ReportLink: () => import(`@/components/reports/ReportLink`),
    BannerNotification: () => import(`@/components/shared/BannerNotification`)
  },
  data() {
    return {
      active: 'ReportDocument'
    };
  },
  computed: {
    disableGroups() {
      let accessLevel = this.$store.getters['auth/getAccessLevel'];
      return (accessLevel && accessLevel.groupReports.value !== true) || false;
    }
  }
};
</script>
<style lang="scss" scoped>
.button {
  background: inherit;
  border: none;
  .icon {
    background: inherit;
  }
}
</style>
